import { z } from "zod";

// Early access: features an account sees on production before everyone
// else, marked Beta with a feedback button. Grants are stored per account
// (account_early_access) and managed only with the API's internal
// early-access script; no public endpoint changes them.
//
// Add a key here before granting it, so a misspelt key fails type checks.
// A feature's pull request adds its key once it has UI behind a flag.
// The API returns only keys from this list; others in the database are
// ignored.
export const EARLY_ACCESS_FEATURES = [
  "guided-first-visit",
  // Radiology dictation: dictate into a saved report template (web).
  "radiology-dictation",
] as const;
export type EarlyAccessFeature = (typeof EARLY_ACCESS_FEATURES)[number];
export const earlyAccessFeatureSchema = z.enum(EARLY_ACCESS_FEATURES);

export const isEarlyAccessFeature = (
  value: unknown,
): value is EarlyAccessFeature =>
  typeof value === "string" &&
  (EARLY_ACCESS_FEATURES as readonly string[]).includes(value);

// Known keys only, once each, in the list's order.
export const knownEarlyAccess = (
  values: readonly unknown[] | null | undefined,
): EarlyAccessFeature[] => {
  const granted = new Set(values ?? []);
  return EARLY_ACCESS_FEATURES.filter((key) => granted.has(key));
};
